import { createSelector } from 'reselect'
import { hasPermission, PermissionLevels } from 'utils/permission'
import { BoardPermission } from './types'

export default function createBoardPermissionSelector (id) {
  return createSelector<any, any, BoardPermission>(
    [
      state => state['view-board'].view[id]?.permissionLevel
    ],
    (permissionLevel) => ({
      reader: hasPermission(permissionLevel, PermissionLevels.READER),
      visitor: hasPermission(permissionLevel, PermissionLevels.VISITOR),
      member: hasPermission(permissionLevel, PermissionLevels.MEMBER),
      owner: hasPermission(permissionLevel, PermissionLevels.OWNER)
    })
  )
}
